export const SESSION_TYPE = {
  ADDRESS: 'address',
  KEYNOTE: 'keynote',
  TALK: 'talk',
  PANEL: 'panel',
  PITCH: 'pitch',
  DEMONSTRATION: 'demonstration',
  WORKSHOP: 'workshop',
  EXERCISE: 'exercise',
  NETWORKING: 'networking',
  OTHER: 'other',
} as const;

export type SessionType = (typeof SESSION_TYPE)[keyof typeof SESSION_TYPE];
